import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingState } from '@ridemaadi/ui';
import { seoForPath } from '../features/public/seoConfig';
import { usePublicPageSeo } from '../features/public/usePublicPageSeo';
import { useAuth } from '../providers/AuthProvider';
import { LandingPageContent } from './LandingPageContent';

/** Public discovery landing - indexable marketing page for unauthenticated visitors. */
export function LandingPage() {
  const { isAuthenticated, isLoading, profileComplete } = useAuth();
  const navigate = useNavigate();

  usePublicPageSeo(seoForPath('/'));

  useEffect(() => {
    if (isLoading) return;
    if (!isAuthenticated) return;
    navigate(profileComplete ? '/dashboard' : '/profile/setup', { replace: true });
  }, [isAuthenticated, isLoading, profileComplete, navigate]);

  if (!isLoading && isAuthenticated) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-bg">
        <LoadingState label="Loading…" />
      </div>
    );
  }

  return <LandingPageContent />;
}
